import styled from 'styled-components';
import { Tabs as MantineTabs } from '@mantine/core';
import { StepStyles as Styled } from '../SetupSteps.styles';
import { mdLight, xxxxsBold } from '@hud/web-components/theme/typography';
import { themeColor } from '@hud/web-components/theme/colors';

export const Tabs = styled(MantineTabs)`
  margin-top: 70px;
  min-width: 400px;

  div[role='tablist'] {
    &:before {
      display: none;
    }

    button[role='tab'] {
      border-top: 1px solid #434547;
      border-right: 1px solid #434547;
      border-bottom: 1px solid #434547;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      transition: all 0.1s ease-in;
      flex: 1;

      svg {
        margin-right: 4px;
        transition: all 0.1s ease-in;
        filter: grayscale(1);
      }

      &[data-active='true'] {
        background: #2a2a2b;
        border-bottom: 1px solid transparent;
        svg {
          filter: grayscale(0);
        }
      }

      &:first-child {
        border-left: 1px solid #434547;
        border-top-left-radius: 10px;
      }

      &:last-child {
        border-right: 1px solid #434547;
        border-top-right-radius: 10px;
      }
    }
  }
`;

export const TabPanel = styled(MantineTabs.Panel)`
  display: flex;
  height: 232px;
  padding: 24px 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;

  border-radius: 0px 0px 8px 8px;
  border-right: 1px solid var(--Stroke-Primary, #434547);
  border-bottom: 1px solid var(--Stroke-Primary, #434547);
  border-left: 1px solid var(--Stroke-Primary, #434547);
  background: #2a2a2b;
`;

export const NumberedList = styled.ol`
  list-style: none;
  counter-reset: item;
  padding: 0;
  margin: 0;
`;

export const NumberedListItem = styled.li`
  counter-increment: item;
  display: flex;
  align-items: start;
  gap: 10px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  &:last-child {
    margin-bottom: 20px;
  }

  ${mdLight};
  color: ${themeColor('textPrimary')};

  &::before {
    content: counter(item);
    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-top: 2px;

    ${xxxxsBold};
    line-height: 12px;
    color: ${themeColor('textPrimary')};
    background-color: ${themeColor('strokeLight')};
  }

  .content.vertical {
    display: flex;
    flex-direction: column;
    justify-items: start;
  }

  p {
    margin: 0;
  }

  a,
  button {
    color: ${themeColor('turquoise')};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  code {
    font-size: 10px;
    margin-left: 5px;
    padding: 2px 6px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #444547;
    background: #1e1f21;
  }

  small {
    color: #999;
    font-size: 12px;
  }
`;

export const ComingSoon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  & svg {
    filter: grayscale(100%);
    opacity: 0.4;
    margin: 15px;
  }

  p {
    margin: 6px 0;
    text-align: center;
    text-wrap: balance;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
    color: ${themeColor('turquoise')};
    transition: color 0.15s ease-in;

    &[disabled] {
      color: #737373;
      cursor: default;
    }
  }
`;

export const Footer = styled(Styled.Footer)`
  margin-top: auto;
`;
